import React from 'react';
import PropTypes from 'prop-types';

// status_id → Tailwind pill classes (1 waiting, 2 approved, 3 rejected, 4 canceled, 5 reset)
const STATUS_CLS = {
  1: 'tw-bg-amber-100 tw-text-amber-700',
  2: 'tw-bg-blue-100 tw-text-blue-700',
  3: 'tw-bg-red-100 tw-text-red-700',
  4: 'tw-bg-red-100 tw-text-red-700',
  5: 'tw-bg-slate-100 tw-text-slate-600',
};

const TransactionStatusBadge = ({ value, data }) => (
  <span className={`tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-xl tw-text-xs tw-font-medium ${STATUS_CLS[data?.status_id] || 'tw-bg-slate-100 tw-text-slate-600'}`}>
    {value}
  </span>
);

TransactionStatusBadge.propTypes = {
  value: PropTypes.node,
  data: PropTypes.shape({
    status_id: PropTypes.number
  })
};

export default TransactionStatusBadge;
